import React from "react";
import styles from "../domain/domain.module.scss";
import ServicesHome from "../reusable/servicesHome/ServicesHome";
import EasySteps from "../easySteps/EasySteps";

const Domain = () => {
  const domain = [
    {
      heading: "Domain Guidance",
      description:
        "Educate users about domains and simplify domain management. it aims to simplify domain management by providing user-friendly tools and guidance for registering, configuring, renewing, and transferring domains.A domain is a unique web address that allows users to access a website.",
    },
  ];
  return (
    <div className={styles.container}>
      <ServicesHome data={domain} />
    </div>
  );
};

export default Domain;
